import React, { Component } from "react";
import { connect } from "react-redux";
import DisplayList from "../DisplayList/DisplayList";

import { url } from "../../../../config/config";
import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import Axios from "axios";

class AuthorBookList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      filterRes: [],
      authorData: [],
      isEmpty: false,
      cartCount: 0,
    };
  }

  async componentDidMount() {
    if (this.props.match.params.authorId !== "All") {
      const response2 = await Axios.get(
        `${url}/api/authors/${this.props.match.params.authorId}`
      );
      this.setState({
        authorData: response2.data,
      });

      const response3 = await Axios.get(`${url}/api/books`, {
        params: {
          author: this.props.match.params.authorId,
        },
      });
      if (response3.data.length !== 0) {
        this.setState({
          filterRes: response3.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          filterRes: [],
          isEmpty: true,
        });
      }
    } else {
      const response1 = await Axios.get(`${url}/api/books`);
      if (response1.data.length !== 0) {
        this.setState({
          books: response1.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          books: [],
          isEmpty: true,
        });
      }
    }
  }

  compare = (a, b) => {
    const nameA = a.title.toUpperCase();
    const nameB = b.title.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  };

  getCartCount = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    this.setState({
      cartCount: response.data.cart.length,
    });
  };

  render() {
    this.state.books.sort(this.compare);
    this.state.filterRes.sort(this.compare);
    return (
      <div>
        <Header cartCount={this.state.cartCount} />
        <div>
          {this.props.match.params.authorId === "All" ? (
            <DisplayList
              authorId={this.props.match.params.authorId}
              bookList={this.state.books}
              isEmpty={this.state.isEmpty}
              getCartCount={this.getCartCount}
            />
          ) : (
            <DisplayList
              authorId={this.props.match.params.authorId}
              authorData={this.state.authorData}
              bookList={this.state.filterRes}
              isEmpty={this.state.isEmpty}
              getCartCount={this.getCartCount}
            />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(mapStateToProps, null)(AuthorBookList);
